import { ReportChartMetaData } from './report-chart-metadata';
import { Options } from '../../highcharts/options';

export class ReportChartData extends ReportChartMetaData {
    data: Options;
}
